import angular from 'angular';
import constants from 'app/constants';
import {
  reportsDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './bulk-archive-report-instances-confirm-dialog.controller';
import template from './bulk-archive-report-instances-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    reportTypeId,
    reportInstanceIds,
  }) {
    return {
      controller,
      controllerAs: 'archiveConfirmDialogVM',
      locals: {
        reportTypeId,
        reportInstanceIds,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.myReports.reportType.bulkArchiveReportInstancesConfirmDialog', [
  alerts,
  reportsDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkArchiveReportInstancesConfirmDialog', dialogService)
  .name;
